import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-access-restriction',
  templateUrl: './access-restriction.component.html',
  styleUrls: ['./access-restriction.component.css']
})
export class AccessRestrictionComponent implements OnInit {

  constructor( private router: Router,) { }

  ngOnInit(): void {
  }
  logout() {
    localStorage.clear();
    this.router.navigate(['sign-in']);
  }

}
